import { render, staticRenderFns } from "./ExternalCompanies.vue?vue&type=template&id=15b64c64&scoped=true"
import script from "./ExternalCompanies.vue?vue&type=script&lang=js"
export * from "./ExternalCompanies.vue?vue&type=script&lang=js"
import style0 from "./ExternalCompanies.vue?vue&type=style&index=0&id=15b64c64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b64c64",
  null
  
)

export default component.exports